export default __webpack_public_path__ + "static/tauron-logo.c9eaa4fb.svg";